var eventMap = {
    // Menu dropdown
    "menu_home": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-home"
    },
    "menu_panamericana": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-panamericana"
    },
    "menu_unidades": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-unidades"
    },
    "menu_vitrine": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-vitrine-de-trabalhos"
    },
    "menu_blog": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-blog"
    },
    "menu_contato": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-contato"
    },
    "menu_curso": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-encontre-seu-curso"
    },
    "menu_aluno": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-quero-ser-aluno"
    },
    "menu_social": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-social"
    },
    // Menu superior
    "superior_aluno": {
        category: "menu-dropdown",
        action: "clique",
        label: "menu-quero-ser-aluno"
    },
    "superior_buscar": {
        category: "menu-dropdown",
        action: "clique",
        label: "buscar"
    },
    "superior_formacao": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-duracao-formacao",
        // value: "formacao"
    },
    "superior_curta_duracao": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-duracao-curta-duracao",
        // value: "curta-duracao"
    },
    "superior_especializacao": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-duracao-especializacao",
        // value: "especializacao"
    },
    // Por area
    "superior_area_animacao_games": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-area-animacao-e-games",
        // value: "animacao-e-games"
    },
    "superior_area_arte_criatividade": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-area-arte-e-criatividade",
        // value: "arte-e-criatividade"
    },
    "superior_area_design_criacao": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-area-design-e-criacao",
        // value: "design-e-criacao"
    },
    "superior_area_fotografia_edicao": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-area-fotografia-e-edicao",
        // value: "fotografia-e-edicao"
    },
    "superior_area_interiores": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-area-interiores",
        // value: "interiores"
    },
    "superior_area_moda_imagem": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-area-moda-e-imagem",
        // value: "moda-e-imagem"
    },
    // Por interesse
    "superior_interesse_animacao": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-interesse-animacao",
        // value: "animacao"
    },
    "superior_interesse_criatividade": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-interesse-criatividade",
        // value: "criatividade"
    },
    "superior_interesse_desenho": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-interesse-desenho",
        // value: "desenho"
    },
    "superior_interesse_mobiliario": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-interesse-mobiliario",
        // value: "mobiliario"
    },
    "superior_interesse_tendencias": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-interesse-tendencias",
        // value: "tendencias"
    },
    "superior_interesse_veja_mais": {
        category: "menu-superior",
        action: "clique",
        label: "menu-por-interesse-veja-mais",
        // value: "veja-mais"
    },
    // Carrosel
    "carrosel": {
        category: "carrosel",
        action: "clique",
        label: "%0%"
    },
    // Home
    "botao_saibamais": {
        category: "botao",
        action: "clique",
        label: "saiba-mais"
    },
    "home_cursos": {
        category: "link",
        action: "clique",
        label: "%0%",
        value: "%0%"
    },
    // Cursos
    "cursos_relacionados": {
        category: "thumbnail",
        action: "clique",
        label: "cursos",
        value: "%0%"
    },
    "cursos_reserva": {
        category: "botao",
        action: "clique",
        label: "cursos-pre-reserva",
        value: "%0%"
    },
    // Pre-reserva
    "reserva_submit": {
        category: "botao",
        action: "clique",
        label: "pre-reserva",
        value: "inscreva-se"
    },
    // 404
    "404_botao_cursos": {
        category: "404",
        action: "clique",
        label: "cursos"
    }
};

module.exports = eventMap;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/libs/metrics.js
// module id = 234
// module chunks = 3